module.exports = __webpack_public_path__ + "img/pageinteriors_individuos-y-familias-02hogar.2a8f1861.jpg";